<template>
  <div>
      <div>
          <b-form-group>
          <b-form-file
                  class="m-2"
                  v-model="file"
                  :state="Boolean(file)"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
          ></b-form-file>
              </b-form-group>



              <b-form-group class="m-2">

                  <span class="color-s" :style="{'background-color': colorDef.primary}"></span>
                  <label class="mr-sm-4">Primary button</label>
                  <b-form-input v-model="color.primary" class="inp" placeholder=""></b-form-input>

              </b-form-group >

              <b-form-group class="m-2">
                  <span class="color-s" :style="{'background-color': colorDef.secondary}"></span>
                  <label class="mr-sm-4">Secondary button</label>
                  <b-form-input v-model="color.secondary" class="inp" placeholder=""></b-form-input>
              </b-form-group>


              <b-form-group class="m-2">
                  <span class="color-s" :style="{'background-color': colorDef.white}"></span>
                  <label class="mr-sm-4">Button text color</label>
                  <b-form-input v-model="color.white" class="inp" placeholder=""></b-form-input>
              </b-form-group>


              <b-form-group class="m-2">
                  <span class="color-s" :style="{'background-color': colorDef.outline}"></span>
                  <label class="mr-sm-4">Outline button</label>
                  <b-form-input v-model="color.outlinew" class="inp" placeholder=""></b-form-input>
              </b-form-group>

              <b-form-group  class="m-2">
                  <span class="color-s" :style="{'background-color': colorDef.outlineColor}"></span>
                  <label class="mr-sm-4">Outline button text color</label>
                  <b-form-input v-model="color.outlineColor" class="inp" placeholder=""></b-form-input>
              </b-form-group>
              <b-form-group class="m-2">
                  <span class="color-s" :style="{'background-color': colorDef.link}"></span>

                  <label class="mr-sm-4">Link color</label>
                  <b-form-input v-model="color.link" class="inp" placeholder=""></b-form-input>
              </b-form-group>

          <div class="m-2"></div>

          <b-button  variant="-secondary" class="m-2" @click="saveColor()">Save</b-button>
          <b-button  variant="-ternary btn--outline"  class="m-2" @click="setDefault()">Set Default</b-button>
      </div>
  </div>
</template>

<script>




  export default {
    name: "Color",
    data() {
      return {
        file: null,
        color:{
          primary: '#289be8',
          secondary: '#5AC557',
          white: '#ffffff',
          outlinew: 'transparent',
          outlineColor: '#5c5c5c',
          link: '#2A9BE8'
        },
        colorDef:{
          primary: '#289be8',
          secondary: '#5AC557',
          white: '#ffffff',
          outlinew: 'transparent',
          outlineColor: '#5c5c5c',
          link: '#2A9BE8'
        },
      }
    },
    methods:{
      setDefault(){
        this.color = this.colorDef;
        //console.log( this.color)
        this.file = null;
        localStorage.removeItem('logo');
        this.saveColor();
      },
      saveColor(){
        if(this.file){


          let reader = new FileReader();
          reader.readAsDataURL(this.file);
          reader.onload = function () {
            localStorage.setItem('logo', reader.result)
          }
        }

       // console.log( getBase64(this.file))
        localStorage.setItem('color', JSON.stringify(this.color))


        for (const [key, value] of Object.entries(this.color)) {
          //console.log(`${key}: ${value}`);
          document.documentElement.style
            .setProperty(`--${key}`, `${value}`);
        }

        window.location.reload()


      },
    }
  }
</script>

<style lang="scss">
    .color-s{
        width: 22px;
        height: 22px;
        display: inline-block;
        border-radius: 50%;
        position: relative;
        top: 5px;
        margin-right: 9px;
    }
    :root {
        --primary: #289be8;
        --secondary: #5AC557;
        --white: #ffffff;
        --outline: transparent;
        --outlinew: transparent;
        --outlineColor:#5c5c5c;
        --link:#2A9BE8;

    }

    /*body{*/
        /*.btn--primary{*/
            /*background-color: var(--primary) !important;*/
            /*border-color:var(--primary) !important;;*/
            /*color: var(--white) !important;*/
        /*}*/
        /*.btn--secondary{*/
            /*background-color: var(--secondary) !important;*/
            /*border-color:var(--secondary) !important;;*/
            /*color: var(--white) !important;*/
        /*}*/
        /*.btn--outline{*/
            /*background-color: var(--outlinew) !important;*/
            /*color: var(--outlineColor) !important;*/
        /*}*/
        /*.nav--main--left a:hover,*/
        /*.nav--main--left a.router-link-active{*/
            /*color: var(--link) !important;*/
        /*}*/
        /*.nav--main--left a:hover:after,*/
        /*.nav--main--left a.router-link-active:after{*/
            /*background: var(--link) !important;;*/
        /*}*/
        /*.btn--tab.btn--primary{*/
            /*background-color: transparent !important;*/
            /*color: var(--link) !important;*/
        /*}*/
    /*}*/
</style>
